(function () {
  var drawer = null;

  function getDrawer() {
    if (!drawer) drawer = document.getElementById('basic-cart-drawer');
    return drawer;
  }

  function updateCartBubbles(count) {
    document.querySelectorAll('.basic-header__cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshDrawer() {
    return fetch('/?sections=basic-cart-drawer')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data['basic-cart-drawer'];
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('#basic-cart-drawer');
        var oldDrawer = getDrawer();
        if (newDrawer && oldDrawer) {
          var wasOpen = oldDrawer.classList.contains('is-open');
          oldDrawer.replaceWith(newDrawer);
          drawer = newDrawer;
          if (wasOpen) {
            newDrawer.classList.add('is-open');
            newDrawer.setAttribute('aria-hidden', 'false');
          }
        }
      });
  }

  function openDrawer() {
    refreshDrawer().then(function () {
      var d = getDrawer();
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function changeLineQuantity(line, quantity) {
    var d = getDrawer();
    if (d) d.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartBubbles(cart.item_count);
        return refreshDrawer();
      })
      .then(function () {
        var d2 = getDrawer();
        if (d2) {
          d2.classList.remove('is-loading');
          d2.classList.add('is-open');
        }
      });
  }

  function addVariant(variantId) {
    var d = getDrawer();
    if (d) d.classList.add('is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartBubbles(cart.item_count);
        return refreshDrawer();
      })
      .then(function () {
        var d2 = getDrawer();
        if (d2) {
          d2.classList.remove('is-loading');
          d2.classList.add('is-open');
          d2.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      });
  }

  function setVariantQuantityById(variantId, quantity) {
    var d = getDrawer();
    if (d) d.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartBubbles(cart.item_count);
        return refreshDrawer();
      })
      .then(function () {
        var d2 = getDrawer();
        if (d2) {
          d2.classList.remove('is-loading');
          d2.classList.add('is-open');
          d2.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      });
  }

  function toggleMini(variantId, isClaimed) {
    if (isClaimed) {
      setVariantQuantityById(variantId, 0);
    } else {
      addVariant(variantId);
    }
  }

  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.basic-header__cart');
    if (cartLink) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var actionEl = e.target.closest('[data-cart-action]');
    if (!actionEl) return;

    var action = actionEl.dataset.cartAction;

    if (action === 'close') {
      closeDrawer();
      return;
    }

    if (action === 'qty-inc' || action === 'qty-dec') {
      var line = parseInt(actionEl.dataset.line, 10);
      var qty = parseInt(actionEl.dataset.qty, 10);
      changeLineQuantity(line, Math.max(0, qty));
      return;
    }

    if (action === 'add') {
      var variantId = actionEl.dataset.variantId;
      if (variantId) addVariant(variantId);
      return;
    }

    if (action === 'toggle-mini') {
      var miniVariantId = actionEl.dataset.variantId;
      var isClaimed = actionEl.dataset.claimed === 'true';
      if (miniVariantId) toggleMini(miniVariantId, isClaimed);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  if (window.location.hash === '#basic-open-cart') {
    history.replaceState(null, '', window.location.pathname + window.location.search);
    openDrawer();
  }
})();